import NavigationDesk from '@ebg/vue-common/src/components/common/navigationdesk/NavigationDesk.vue'

export default {
  name: 'Home',
  components: {
    NavigationDesk
  },
  beforeMount () {
    // @TODO move logic to index.js router.beforeEach
    const requestedPath = localStorage.getItem('requested_path');
    if (requestedPath) {
      localStorage.removeItem('requested_path');
      this.$router.push(requestedPath);
    }
  }
}
